module.exports = __webpack_public_path__ + "img/bottom.6347d88a.png";